import React from "react";
import HeaderMobile from "./headerMobile";
import HeaderDesktop from "./headerDesktop";
import './headerMedallero.sass';

export default function Header({ ascendente, descendente, ordenAlfabetico, ordenBronce, ordenOro, ordenPlata, ordenTotal, FilterGold, FilterSilver, FilterBronce, FilterAlfabetico, FilterTotal }) {

    return (
        <div className="medallero-header">
            <div className="medallero-header-equipo" onClick={() => FilterAlfabetico()}  >
                NOC
                <div className="arrows">
                    <div className={ordenAlfabetico === descendente ? "arrow-top active" : "arrow-top"} ></div>
                    <div className={ordenAlfabetico === ascendente ? "arrow-bottom active" : "arrow-bottom"} ></div>
                </div>
            </div>

            <HeaderDesktop
                ascendente={ascendente}
                descendente={descendente}
                ordenBronce={ordenBronce}
                ordenOro={ordenOro}
                ordenPlata={ordenPlata}
                ordenTotal={ordenTotal}
                FilterGold={FilterGold}
                FilterSilver={FilterSilver}
                FilterBronce={FilterBronce}
                FilterTotal={FilterTotal} 
            />

            <HeaderMobile
                ascendente={ascendente}
                descendente={descendente}
                ordenBronce={ordenBronce}
                ordenOro={ordenOro}
                ordenPlata={ordenPlata}
                ordenTotal={ordenTotal}
                FilterGold={FilterGold}
                FilterSilver={FilterSilver}
                FilterBronce={FilterBronce}
                FilterTotal={FilterTotal}
            />
        </div>
    )
}